// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"Navbar_dropdownMenu__1WwB0","boldText":"Navbar_boldText__gzH-E"};